<template>
  <c-row>
    <c-col sm="6" lg="3">
      <c-widget-dropdown color="gradient-primary" header="9.823" text="Members online">
        <template #default>
          <c-dropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <c-icon name="cil-settings" />
            </template>
            <c-dropdown-item>Action</c-dropdown-item>
            <c-dropdown-item>Another action</c-dropdown-item>
            <c-dropdown-item>Something else here...</c-dropdown-item>
            <c-dropdown-item disabled>Disabled action</c-dropdown-item>
          </c-dropdown>
        </template>
        <template #footer>
          <c-chart-line-simple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[65, 59, 84, 84, 51, 55, 40]"
            point-hover-background-color="primary"
            label="Members"
            labels="months"
          />
        </template>
      </c-widget-dropdown>
    </c-col>
    <c-col sm="6" lg="3">
      <c-widget-dropdown color="gradient-info" header="9.823" text="Members online">
        <template #default>
          <c-dropdown color="transparent p-0" placement="bottom-end" :caret="false">
            <template #toggler-content>
              <c-icon name="cil-location-pin" />
            </template>
            <c-dropdown-item>Action</c-dropdown-item>
            <c-dropdown-item>Another action</c-dropdown-item>
            <c-dropdown-item>Something else here...</c-dropdown-item>
            <c-dropdown-item disabled>Disabled action</c-dropdown-item>
          </c-dropdown>
        </template>
        <template #footer>
          <c-chart-line-simple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[1, 18, 9, 17, 34, 22, 11]"
            point-hover-background-color="info"
            :options="{ elements: { line: { tension: 0.00001 } } }"
            label="Members"
            labels="months"
          />
        </template>
      </c-widget-dropdown>
    </c-col>
    <c-col sm="6" lg="3">
      <c-widget-dropdown color="gradient-warning" header="9.823" text="Members online">
        <template #default>
          <c-dropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <c-icon name="cil-settings" />
            </template>
            <c-dropdown-item>Action</c-dropdown-item>
            <c-dropdown-item>Another action</c-dropdown-item>
            <c-dropdown-item>Something else here...</c-dropdown-item>
            <c-dropdown-item disabled>Disabled action</c-dropdown-item>
          </c-dropdown>
        </template>
        <template #footer>
          <c-chart-line-simple
            class="mt-3"
            style="height:70px"
            background-color="rgba(255,255,255,.2)"
            :data-points="[78, 81, 80, 45, 34, 12, 40]"
            :options="{ elements: { line: { borderWidth: 2.5 } } }"
            point-hover-background-color="warning"
            label="Members"
            labels="months"
          />
        </template>
      </c-widget-dropdown>
    </c-col>
    <c-col sm="6" lg="3">
      <c-widget-dropdown color="gradient-danger" header="9.823" text="Members online">
        <template #default>
          <c-dropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <c-icon name="cil-settings" />
            </template>
            <c-dropdown-item>Action</c-dropdown-item>
            <c-dropdown-item>Another action</c-dropdown-item>
            <c-dropdown-item>Something else here...</c-dropdown-item>
            <c-dropdown-item disabled>Disabled action</c-dropdown-item>
          </c-dropdown>
        </template>
        <template #footer>
          <c-chart-bar-simple
            class="mt-3 mx-3"
            style="height:70px"
            background-color="rgb(250, 152, 152)"
            label="Members"
            labels="months"
          />
        </template>
      </c-widget-dropdown>
    </c-col>
  </c-row>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from '../charts/index.js';

export default {
  name: 'WidgetsDropdown',
  components: { CChartLineSimple, CChartBarSimple },
};
</script>
